import React from 'react';
import Link from '../components/Link';
import Line from '../components/Line';
import {
    bet365 as bet365Urls,
} from '../urlConstants';
import '../styles.scss';

const Bet365 = () => (
    <div className="bs-gamblingCompliance bs-gamblingCompliance--short">
        <Line>
            Best Odds Guaranteed. Take a price and if the starting
        </Line>
        <Line>
            price is bigger, bet365 pays at the bigger odds.
        </Line>

        <Line className="bs-gamblingCompliance__line--spacer">
            <Link
                href="https://extra.bet365.com/promotions/en/horse-racing/best-odds-guaranteed"
                text="Bet restrictions and T&Cs apply"
            />. New and eligible customers only.
        </Line>
        <Line>
            Bets are accepted in accordance with
        </Line>
        <Line className="bs-gamblingCompliance__line--spacer">
            the operator&#39;s&nbsp;
            <Link href={bet365Urls.rules} text="rules" />&nbsp;
            and&nbsp;
            <Link
                href={bet365Urls.termsAndConditions}
                text="terms and conditions"
            />.&nbsp;
        </Line>
        <Line>
            Hillside (UK Sports) ENC is licensed and regulated
            by the British Gambling Commissioner (Account Number 55148, Registration Number P1892)
        </Line>
    </div>
);

export default Bet365;



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/Bet365/shortGamblingCompliance.jsx